export const FETCH_LAYERS_REQUEST = 'layer/FETCH_LAYERS_REQUEST'
export const FETCH_LAYERS_SUCCESS = 'layer/FETCH_LAYERS_SUCCESS'
export const FETCH_LAYERS_FAILURE = 'layer/FETCH_LAYERS_FAILURE'

export const FETCH_LAYER_REQUEST = 'layer/FETCH_LAYER_REQUEST'
export const FETCH_LAYER_SUCCESS = 'layer/FETCH_LAYER_SUCCESS'
export const FETCH_LAYER_FAILURE = 'layer/FETCH_LAYER_FAILURE'

export const DELETE_LAYER_REQUEST = 'layer/DELETE_LAYER_REQUEST'
export const DELETE_LAYER_SUCCESS = 'layer/DELETE_LAYER_SUCCESS'
export const DELETE_LAYER_FAILURE = 'layer/DELETE_LAYER_FAILURE'

export const CREATE_LAYER_REQUEST = 'layer/CREATE_LAYER_REQUEST'
export const CREATE_LAYER_SUCCESS = 'layer/CREATE_LAYER_SUCCESS'
export const CREATE_LAYER_FAILURE = 'layer/CREATE_LAYER_FAILURE'

export const UPDATE_LAYER_REQUEST = 'layer/UPDATE_LAYER_REQUEST'
export const UPDATE_LAYER_SUCCESS = 'layer/UPDATE_LAYER_SUCCESS'
export const UPDATE_LAYER_FAILURE = 'layer/UPDATE_LAYER_FAILURE'

export const UPLOAD_LAYER_FILE_REQUEST = 'layer/UPLOAD_LAYER_FILE_REQUEST'
export const UPLOAD_LAYER_FILE_SUCCESS = 'layer/UPLOAD_LAYER_FILE_SUCCESS'
export const UPLOAD_LAYER_FILE_FAILURE = 'layer/UPLOAD_LAYER_FILE_FAILURE'

export const UPDATE_FIELD = 'layer/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'layer/SET_DEFAULT_DATA'
